import { type ReactNode } from 'react';
import SuppliesPage from './supplies/supplies.page';
import BeveragesPage from './beverages/beverages.page';
import { Flex } from 'antd';

const BeveragesAndSuppliesPage = (): ReactNode => {
  return (
    <Flex gap="middle" vertical>
      <BeveragesPage />
      <SuppliesPage />
    </Flex>
  );
};

BeveragesAndSuppliesPage.displayName = 'BeveragesAndSuppliesPage';
export default BeveragesAndSuppliesPage;
